import React from "react";
import { Snackbar, Alert } from "@mui/material";

const Toast = ({
    open,
    onClose,
    message,
    severity = "info",
    autoHideDuration = 4000,
    anchorOrigin = { vertical: "bottom", horizontal: "right" },
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
        >
            <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: "100%" }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default Toast;